import { useRequest } from 'ahooks'

import { getYidongDict } from '../service'
/**
 * 异动数据 - 注入业务数据
 * @param param0
 * @returns
 */
const useYiDong = ({ zidianStore, enable }: { zidianStore: any; enable: boolean }) => {
  useRequest(() => getYidongDict(), {
    manual: !enable,
    onSuccess: ({ success, data }) => {
      if (success) {
        const dicts = data?.map((item: any) => ({
          type: item.type,
          type_code: `PropertyDict${item.type}`,
          setting_list: item.details
        }))
        // 添加字典
        zidianStore.addDicts(dicts)
      }
    }
  })
}
export default useYiDong
